import axios from 'axios'
import match from 'js-pattern-matching'
import Qs from 'qs'
import route from '../router'
import store from '../store/index'
import { gotoCxLogin } from '@/common/login'
import getBrowserFingerprint from 'babel-loader!get-browser-fingerprint'
import Vue from 'vue'
import { mergeDeepRight } from 'ramda'

export let fingerprint = null
try {
  fingerprint = getBrowserFingerprint({ hardwareOnly: true })
} catch (e) {
  console.log(e)
}
const getEnv = require('../../get-env')
const ENV = getEnv()

const CMMURL = match(ENV)(
  (v = 'dev') => 'https://sv-api-test.cds8.cn',
  (v = 'test') => 'https://sv-api-test.cds8.cn',
  (v = 'stage') => 'https://sv-api-stage.cds8.cn',
  (v = 'prod') => 'https://api-service.chanmama.com',
  (_) => ''
)

export const JXURL = match(ENV)(
  (v = 'dev') => 'https://cmm-jx-test-api.cds8.cn',
  (v = 'test') => 'https://cmm-jx-test-api.cds8.cn',
  (v = 'stage') => 'https://cmm-jingxuan-stage-api.cds8.cn',
  (v = 'prod') => 'https://api-service.chanxuan.com',
  (_) => ''
)

export const CASURL = match(ENV)(
  (v = 'dev') => 'https://cmm-cas-test.cds8.cn',
  (v = 'test') => 'https://cmm-cas-test.cds8.cn',
  (v = 'stage') => 'https://cmm-cas-stage.cds8.cn',
  (v = 'prod') => 'https://passport.chanmama.com',
  (_) => ''
)

export const CJURL = match(ENV)(
  (v = 'dev') => 'https://ck-clip-api-test.cds8.cn',
  (v = 'test') => 'https://ck-clip-api-test.cds8.cn',
  (v = 'stage') => 'https://ck-clip-api-stage.cds8.cn',
  (v = 'prod') => 'https://api-service.chanjian.cc',
  (_) => ''
)

export function getBaseUrl(serviceType) {
  return match(serviceType)(
    (v = 0) => JXURL,
    (v = 1) => CMMURL,
    (v = 2) => CASURL,
    (v = 3) => CJURL
  )
}

// 登入错误码
export const loginErrCodeList = [40004, 40005, 40006, 40007, 42014, 40015, 40002, 40003]

// 维护错误码
export function getMaintainErrCodes() {
  return [10000]
}
// 用户没有同意隐私错误码
export function getErrorPrivacyCode() {
  return [40008]
}

export function link(reqUrl, data) {
  return `${getBaseUrl()}/${reqUrl}?${Qs.stringify(data)}`
}

async function checkStatus(response) {
  const responseData = response.data
  if (responseData.data && response.config.option.encrypt) {
    const res = await aesDecrypt(responseData.data)
    responseData.data = JSON.parse(res)
  }
  if (responseData) {
    if (typeof responseData.errCode === 'undefined') {
      responseData.errCode = responseData.code
    }
    if (typeof responseData.errMsg === 'undefined') {
      responseData.errMsg = responseData.message
    }
  }
  const errCode = responseData.errCode
  const errorPrivacyCode = getErrorPrivacyCode()
  const maintainErrCodes = getMaintainErrCodes()
  if (errorPrivacyCode.includes(errCode)) {
    Vue.prototype.$EventBus.$emit('onOpenAgreePrivacyDialog')
    return null
  }
  if (response?.config?.option?.commonCheck && loginErrCodeList.includes(errCode)) {
    if (errCode === 42014) {
      store.state.instance.loginDialog.open()
      return
    }
    gotoCxLogin()
    return null
  }
  if (maintainErrCodes.includes(errCode)) {
    route.replace({ path: '/maintain' })
    return null
  }
  return response
}

const service = axios.create({
  baseURL: getBaseUrl(0),
  timeout: 60 * 1000,
  headers: {
    'X-Client-Id': fingerprint,
    'x-platform-id': 10009 // 来源的标记10009表示来源pc
  },
  withCredentials: true
})
//http request 拦截器
service.interceptors.request.use(
  (config) => {
    const option =
      config.option ?? {}
      |> mergeDeepRight({
        commonCheck: true,
        serviceType: 0
      })
    config.option = option
    const { serviceType } = option

    // 配置请求头
    config.headers = {
      ...config.headers,
      [serviceType === 0 ? 'X-Authorization-Cx' : 'Authorization']: store.state.user.token ?? ''
    }
    config.baseURL = `${getBaseUrl(serviceType)}`
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

//http response 拦截器
service.interceptors.response.use(
  async (response) => {
    // console.log(response)
    // const { commonCheck } = response?.config?.option ?? {}

    return await checkStatus(response)
  },
  (error) => {
    if (error.code === 'ERR_CANCELED') {
      return { data: { errCode: error.code, errMsg: error.message, code: error.code } }
    }
    const { response } = error
    if (response) {
      // showMessage(response.status);
      return Promise.reject(response.data)
    } else {
      // Message.warning('网络连接异常,请稍后再试!')
    }
  }
)

export default async function (url, config, option = {}) {
  if (option.encrypt) {
    for (const dataKey of ['data', 'params']) {
      const params = config[dataKey]
      if (params) {
        const keys = Object.keys(params)
          .map((key) => key + '=' + params[key])
          .join('&')
        const encryptParams = await aesEncrypt(keys)
        // const encodeParams = Base64.encode(encryptParams)
        config[dataKey] = { encode: encryptParams, encrypt: 1 }
      }
    }
  }
  return service(url, { ...config, option })
}
export async function aesEncrypt(text, keyWord = '9rDal3705V6xVMLL') {
  const CryptoJS = await import('crypto-js')
  const key = CryptoJS.enc.Utf8.parse(keyWord)
  const data = CryptoJS.enc.Utf8.parse(text)
  const encrypted = CryptoJS.AES.encrypt(data, key, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    iv: key
  })
  return encrypted.toString()
}

export async function aesDecrypt(ciphertext, keyWord = '9rDal3705V6xVMLL') {
  const CryptoJS = await import('crypto-js')
  const key = CryptoJS.enc.Latin1.parse(keyWord)
  const bytes = CryptoJS.AES.decrypt(ciphertext, key, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    iv: key
  })
  return bytes.toString(CryptoJS.enc.Utf8)
}
